import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Workprocess } from 'app/examination/workprocess';
import * as Raven from 'raven-js';

@Injectable()
export class StateService {

    private stateUpdated = new Subject();
    public stateUpdated$ = this.stateUpdated.asObservable();

    public set datacheck(value: boolean) {
        let val = '0';
        if (value) {
            val = '1';
        }
        sessionStorage.setItem('data-check', val);
        this.stateUpdated.next();
    };

    public get datacheck(): boolean {
        return sessionStorage.getItem('data-check') === '1';
    }

    public set workProcesses(items) {
        this._workprocesses = items;
        this.stateUpdated.next();
    };

    public get workProcesses() {
        return this._workprocesses;
    };

    private _workprocesses = new Array<Workprocess>();

    public getNextRoute(currentRoute: string) {
        if (currentRoute === 'data-check') {
            return this.workProcesses[0].code;
        }

        const index = this.workProcesses.findIndex(wp => wp.code === currentRoute);
        if (index === this.workProcesses.length - 1) {
            return 'results';
        }

        return this.workProcesses[index + 1].code;
    }

    constructor(private route: ActivatedRoute) {
    }

    public resetState() {
        this.workProcesses = new Array<Workprocess>();
        this.datacheck = false;
    }

    public workprocessDone(process, done) {
        if (this.workProcesses) {
            const index = this.workProcesses.findIndex(wp => wp.code === process);
            this.workProcesses[index].done = done;

            if (Raven.isSetup()) {
                Raven.captureBreadcrumb({
                    message: 'Extra informatie statefout',
                    category: 'action',
                    data: {
                        index: index,
                        workprocesses: this.workProcesses,
                        object: this.workProcesses[index]
                    }
                });
            }
        }
    }

    public allStepsAreDone() {
        const values = this.workProcesses.filter(item => {
            if (Raven.isSetup()) {
                Raven.captureBreadcrumb({
                    message: 'Extra informatie statefout',
                    category: 'action',
                    data: {
                        workprocesses: this.workProcesses,
                        item: item
                    }
                });
            }

            return item.done === false;
        });

        return values.length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/state.service.ts